/**
 * implementation of <BattleModeFilter /> for selecting vehicles for unit autosearch
 * @see https://confluence.wargaming.net/display/WEBDEV/%5BLeg%5D+UI+Legionaries+draft
 */
import { connect } from 'react-redux'

import { setBattleModeFilter } from 'state/actions/players_matching'
import { BATTLE_ROOMS_TAB_STATES, UNIT_TYPES } from 'constants'

import { BattleModeFilter } from '../BattleModeFilter'
import { sortBattleModeSettings } from '../helpers'

export const mapStateToProps = ({ availableUnits, players_matching }) => {
    const shouldShowTab = (battleMode) => {
        if (battleMode.unit_type === UNIT_TYPES.FORT_BATTLE) return false

        return players_matching.sortie_settings.some((setting) => (
            (setting.level === battleMode.max_vehicle_level) &&
                (setting.enabled || setting.show_challenges_message)
        ))
    }

    const battleModesSettings = availableUnits.meta.battle_modes_settings.filter(shouldShowTab)

    return {
        tab: BATTLE_ROOMS_TAB_STATES.MATCHING,
        selectedUnitType: UNIT_TYPES.SORTIE,
        selectedVehicleLevel: players_matching.vehicle_level,
        battleModesSettings: sortBattleModeSettings(battleModesSettings),
    }
}

const mapDispatchToProps = {
    onChange: (unit_type, vehicle_level) => setBattleModeFilter(vehicle_level),
}

export default connect(mapStateToProps, mapDispatchToProps)(BattleModeFilter)



// WEBPACK FOOTER //
// ./containers/BattleRooms/components/BattleModeFilter/containers/PlayersMatchingBattleModeFilter.jsx